export default __webpack_public_path__ + "2646d3103f8f15cda1ece77a717cb40d-gotham-book-webfont.woff";